import React from "react";
// import bg8 from '../../assets/images/background/bg-8.png';
// import bg7 from '../../assets/images/background/bg-7.png';
import whyiconone from "../../assets/images/resource/hygienic-food.png";
import whyicontwo from "../../assets/images/resource/fresh-env.png";
import whyiconthree from "../../assets/images/resource/chefs.png";
import whyiconfour from "../../assets/images/resource/catering.png";

function Whyus() {
    const whyData = [
        {
            icon: whyiconone,
            title: "Fresh and thoughtfully prepared",
            text: "Prepared in a spotless kitchen with fresh, carefully handled ingredients, following strict safety standards every day.",
        },
        {
            icon: whyicontwo,
            title: "A welcoming atmosphere",
            text: "Bright, airy, and welcoming spaces with natural accents and calming music for a relaxed dining experience.",
        },
        {
            icon: whyiconthree,
            title: "Skilled Chefs",
            text: "Our chefs craft each dish with technique and passion, balancing classic flavors with thoughtful presentation.",
        },
        {
            icon: whyiconfour,
            title: "Catering",
            text: "From intimate gatherings to large events, we deliver timely, delicious menus tailored to your guests and budget.",
        },
    ];

    return (
        <>
            <section className="why-us">
                {/* <div className="left-bg">
          <img src={bg8} alt="" title="" />
        </div>
        <div className="right-bg">
          <img src={bg7} alt="" title="" />
        </div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>why choose us</span>
                        </div>
                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h2>Our Focus</h2>
                    </div>
                    <div className="row clearfix">
                        {whyData.map((data, index) => (
                            <div
                                key={index}
                                className="why-block col-xl-3 col-lg-6 col-md-6 col-sm-12"
                            >
                                <div
                                    className="inner-box wow fadeInUp"
                                    data-wow-duration="1500ms"
                                    data-wow-delay={`${index * 300}ms`}
                                >
                                    <div className="icon-box">
                                        <img src={data.icon} alt="" />
                                    </div>
                                    <h4>{data.title}</h4>
                                    <div className="text">{data.text}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Whyus;
